import styled from 'styled-components'
import { mildGray, inputShadow, softGray } from '../../styles/variables.js'
import { fieldLabel } from '../../styles/common'

const Input = styled.div`
  padding: 10px 0 20px;
  display: flex;
  flex-direction: column;
  position: relative;
  min-width: 250px;

  ${fieldLabel}

  select {
    padding: 7px 8px 9px 8px;
    appearance: none;
    background: white;
    border: none;
    outline: none;
    font-size: 16px;
    flex: 1 1;
    padding-right: 26px;
    max-width: 100%;
  }

  select::-ms-expand {
    display: none;
  }
`

const InputContainer = styled.div`
  background: white;
  box-shadow: ${inputShadow};
  display: flex;
  flex-direction: row;
  position: relative;
  border: 1px solid white;
  &:hover .onHover {
    transform: scale(1.1);
    color: black;
  }

  &:hover .onHover.disabled {
    transform: none;
    color: ${mildGray};
    opacity: 0.4;
  }

  ${({ inverted }) => inverted ? `
    background: ${softGray};
    border: 1px solid ${softGray};
    & > select {
      background: ${softGray};
    }
  ` : ''}

  ${({ error }) => error ? `
    border: 1px solid red !important;
  ` : ''}

`

const ErrorLabel = styled.label`
  position: absolute;
  bottom: -6px;
  color: red !important;
  margin-top: 4px;
`

const Icon = styled.div`
  position: absolute;
  right: 8px;
  top: 8px;
  cursor: pointer;
  transition: all .1s ease-in-out;
  color: ${mildGray};
  pointer-events: none;

  &.disabled {
    transform: none;
    color: ${mildGray};
    opacity: 0.4;
  }
`

export default {
  Input,
  InputContainer,
  ErrorLabel,
  Icon,
}
